import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SOCIALS } from "./socials";

export default function Footer() {
  return (
    <footer className="bg-[#08182a] text-white/80">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src="/brand/bella-logo-white.png"
            alt="Bella Edifices"
            className="h-12 w-auto object-contain"
          />
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/60">
            Solution clé en main pour le financement et l'achat immobilier au
            Mexique. Nous accompagnons les investisseurs francophones à chaque
            étape.
          </p>
          <div className="flex gap-3 mt-6">
            {SOCIALS.map(({ name, href, Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={name}
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#2f74c9] hover:text-white hover:border-[#2f74c9] transition-colors"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-600 mb-4 tracking-wide">Navigation</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-[#2f74c9]">Accueil</Link></li>
            <li><Link to="/proprietes" className="hover:text-[#2f74c9]">Propriétés</Link></li>
            <li><Link to="/formations" className="hover:text-[#2f74c9]">Formations</Link></li>
            <li><Link to="/evenements" className="hover:text-[#2f74c9]">Événements</Link></li>
            <li><Link to="/admin" className="hover:text-[#2f74c9]">Espace admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-600 mb-4 tracking-wide">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin size={18} className="text-[#2f74c9] mt-0.5" /> Playa del Carmen, Quintana Roo, MX</li>
            <li className="flex items-center gap-3"><Phone size={18} className="text-[#2f74c9]" /> +52 984 000 0000</li>
            <li className="flex items-center gap-3"><Mail size={18} className="text-[#2f74c9]" /> info@bellaedifices.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Bella Edifices. Tous droits réservés.</span>
          <span>Financement · Investissement · Mexique</span>
        </div>
      </div>
    </footer>
  );
}
